import controller from './categories-menu.controller';
import templateBase from './templates/categories-menu-base.view.html';
import templateT1 from './templates/categories-menu-t1.html';
let CategoriesMenuComponent = {
    template: changeTemplate,
    controller,
    bindings: {
        items: '<',
        hCtrl: '<'
    }
};

changeTemplate.$inject = ['SessionService'];

function changeTemplate(SessionService) {
    let response = SessionService.get('components');
    if(response.HEADER_MENU.component == 'template_t1') {
      return templateT1;
    } else {
      return templateBase;
    }


}

export default CategoriesMenuComponent;



/** WEBPACK FOOTER **
 ** ./www/components/home/categories-menu/categories-menu.component.js
 **/